import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
    fetchPresets,
    onImageViewerSetPreferred,
    onImageViewerToggleOriginal
} from '../actions/PresetActions';
import isEmpty from 'lodash/isEmpty';
import Error from '../components/Error';
import Loading from '../components/Loading';
import {PresetsToolbar} from '../components/PresetsToolbar';
import {onActiveImageChanged} from '../actions/EditorActions';
import {maybe} from '../utils';
import {onAmplitudeOrScaleChange} from '../actions/ImageActions';

@connect(state => ({presets: state.presets, openImage: state.openImage}), {
    fetchPresets,
    onActiveImageChanged,
    onAmplitudeOrScaleChange,
    onImageViewerToggleOriginal,
    onImageViewerSetPreferred
})
export default class PresetsToolbarContainer extends Component {
    static propTypes = {
        fetchPresets: PropTypes.func,
        presets: PropTypes.shape({
            loading: PropTypes.bool,
            error: PropTypes.object,
            items: PropTypes.object
        }),
        openImage: PropTypes.object,
        onAmplitudeOrScaleChange: PropTypes.func,
        onImageViewerSelectCustom: PropTypes.func,
        onImageViewerToggleOriginal: PropTypes.func,
        preferredAmplitude: PropTypes.number.isRequired,
        preferredSpread: PropTypes.number.isRequired,
        onImageViewerSetPreferred: PropTypes.func,
        onActiveImageChanged: PropTypes.func,
    };

    componentDidMount() {
        this.props.fetchPresets();
    }

    render() {
        const {presets, openImage, preferredAmplitude, preferredSpread} = this.props;
        if (isEmpty(presets)) {
            return false;
        }
        const {loading, error, items} = presets;
        if (!isEmpty(error)) {
            return <Error error={error}/>;
        }
        if (loading) {
            return <Loading/>;
        }

        const {id, amplitude, spread, isOriginalActive, activeImage} = openImage;

        return (
            <PresetsToolbar
                imageId={id}
                presets={items}
                amplitude={maybe(amplitude, preferredAmplitude)}
                spread={maybe(spread, preferredSpread)}
                activeImage={activeImage}
                onAmplitudeOrScaleChange={this.props.onAmplitudeOrScaleChange}
                onImageViewerToggleOriginal={this.props.onImageViewerToggleOriginal}
                isOriginalActive={isOriginalActive}
                preferredAmplitude={preferredAmplitude}
                preferredSpread={preferredSpread}
                onImageViewerSetPreferred={this.props.onImageViewerSetPreferred}
                onActiveImageChanged={this.props.onActiveImageChanged}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PresetsToolbarContainer.js